
import { defineComponent, PropType } from 'vue'
import { AxiosResponse } from 'axios'
import { iBusinessModel } from '../../../Metaweb'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import metawebPhysicalTableTabDescriptor from './MetawebPhysicalTableTabDescriptor.json'
import MetawebAddPhysicalTableDialog from './metawebAddPhysicalTableDialog/MetawebAddPhysicalTableDialog.vue'

const { generate, applyPatch } = require('fast-json-patch')

export default defineComponent({
    name: 'metaweb-physical-table-tab',
    props: { selectedBusinessModel: { type: Object as PropType<iBusinessModel | null> }, propMeta: { type: Object }, observer: { type: Object } },
    components: { Column, DataTable, MetawebAddPhysicalTableDialog },
    data() {
        return {
            metawebPhysicalTableTabDescriptor,
            meta: null as any,
            businessModel: null as iBusinessModel | null,
            physicalTables: [] as any,
            filters: {
                global: [filterDefault]
            } as Object,
            availablePhysicalTables: [] as any[],
            addTableDialogVisible: false,
            loading: false
        }
    },
    watch: {
        selectedBusinessModel() {
            this.loadData()
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.loadMeta()
            this.loadBusinessModel()
        },
        loadMeta() {
            this.meta = this.propMeta as any
        },
        loadBusinessModel() {
            this.businessModel = this.selectedBusinessModel as iBusinessModel
            this.loadPhysicalTables()
        },
        loadPhysicalTables() {
            this.physicalTables = []
            if (this.businessModel) {
                this.businessModel.physicalTables?.forEach((el: any) => this.physicalTables.push(this.meta.physicalModels[el.physicalTableIndex]))
            }
        },
        openAddPhysicalTableDialog() {
            this.availablePhysicalTables = [...this.meta.physicalModels]
            const indexesToRemove = this.businessModel?.physicalTables?.map((el: any) => el.physicalTableIndex).sort()

            if (indexesToRemove) {
                for (let i = indexesToRemove.length - 1; i >= 0; i--) {
                    this.availablePhysicalTables.splice(indexesToRemove[i], 1)
                }
            }

            this.addTableDialogVisible = true
        },
        deletePhysicalTableConfirm(physicalTable: any) {
            this.$confirm.require({
                message: this.$t('documentExecution.dossier.deleteConfirm'),
                header: this.$t('documentExecution.dossier.deleteTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: async () => await this.deletePhysicalTable(physicalTable)
            })
        },
        async deletePhysicalTable(physicalTable: any) {
            this.loading = true
            const postData = { data: { viewUniqueName: this.businessModel?.uniqueName, physicalTable: physicalTable.name } }
            await this.$http
                .post(process.env.VUE_APP_META_API_URL + `/1.0/metaWeb/deletePhysicalColumnfromBusinessView`, postData)
                .then((response: AxiosResponse<any>) => {
                    this.meta = applyPatch(this.meta, response.data).newDocument
                    this.loadData()

                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('common.toast.deleteSuccess')
                    })
                    generate(this.observer)
                })
                .catch(() => {})
            this.loading = false
        },
        async addNewPhysicalTables(selectedTables: any[]) {
            this.loading = true
            const postData = { data: { viewUniqueName: this.businessModel?.uniqueName, physicalTables: selectedTables.map((el: any) => el.name) }, diff: generate(this.observer) }
            await this.$http
                .post(process.env.VUE_APP_META_API_URL + `/1.0/metaWeb/addPhysicalColumnToBusinessView`, postData)
                .then((response: AxiosResponse<any>) => {
                    this.meta = applyPatch(this.meta, response.data).newDocument
                    this.loadData()

                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.createTitle'),
                        msg: this.$t('common.toast.createSuccess')
                    })
                    this.addTableDialogVisible = false
                    generate(this.observer)
                })
                .catch(() => {})
            this.loading = false
        }
    }
})
